
import React, { useState, useEffect } from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SpiritGuideAvatar = ({ message }) => {
  const { t } = useTranslation();
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    if (message) {
      setShowMessage(true);
      const timer = setTimeout(() => setShowMessage(false), 5000); // Message disappears after 5 seconds
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <div className="relative flex flex-col items-center mb-8">
      <img 
        src="https://placehold.co/100x100/818cf8/FFFFFF/png?text=SG" 
        alt={t('spiritGuideAvatar.altText')} 
        className="w-24 h-24 rounded-full object-cover border-4 border-indigo-400 shadow-lg animate-pulse-slow"
      />
      {showMessage && message && (
        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-full bg-gray-800 border border-indigo-500 rounded-lg p-3 text-sm text-white shadow-xl animate-fadeInUp max-w-xs">
          <p>{message}</p>
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-gray-800"></div>
        </div>
      )}
      <h3 className="text-xl font-bold text-indigo-300 mt-2">{t('spiritGuideAvatar.name')}</h3>
      <p className="text-sm text-gray-400">{t('spiritGuideAvatar.description')}</p>
    </div>
  );
};

export default SpiritGuideAvatar;
